<template>
  <div class="flex flex-col gap-2 w-full min-h-96">
    <V4RemindersHeader />
    <DeferredContent @on-load-component="handleFetchReminders">
      <div class="min-h-96 w-full">
        <div class="flex flex-col gap-2" v-if="!loadingReminders">
          <V4ReminderDescription
            v-for="reminder in reminders"
            :key="reminder.id"
            :reminder="reminder"
            :date="formatDateToday(reminder.assignedDateTime)"
            :time="dateFormat(reminder.assignedDateTime, 'hh:mm A')"
            :start-date="dateFormat(reminder.assignedDateTime)"
          />
        </div>
        <V4LoadingEventsAndReminder v-if="loadingReminders" />
        <V4EmptyEventsAndReminder
          text="No Reminders"
          v-if="!loadingReminders && reminders.length === 0"
        />
      </div>
    </DeferredContent>
  </div>
</template>

<script setup>
import { useHomeEventsAndRemindersStore } from "@/stores/home/useHomeEventsAndReminders.store";
import DeferredContent from "@/components/utilities/DeferredContent.vue";
import { storeToRefs } from "pinia";
import { formatDateToday, dateFormat } from "@/helpers/date_formatter";
import V4RemindersHeader from "./reminders/V4RemindersHeader.vue";
import V4ReminderDescription from "./reminders/V4ReminderDescription.vue";
import V4EmptyEventsAndReminder from "./reminders/V4EmptyEventsAndReminder.vue";
import V4LoadingEventsAndReminder from "./reminders/V4LoadingEventsAndReminder.vue";

const homeEventsAndReminderStore = useHomeEventsAndRemindersStore();

const { loadingReminders, reminders } = storeToRefs(homeEventsAndReminderStore);

const handleFetchReminders = async () => {
  await homeEventsAndReminderStore.handleFetchReminders();
};
</script>

<style lang="scss" scoped></style>
